import { ID, Currency } from './common';

export const CfeTipoCode = {
  ETICKET: 101,
  NOTA_CREDITO_ETICKET: 102,
  RESGUARDO: 182,
} as const;
export type CfeTipoCode = typeof CfeTipoCode[keyof typeof CfeTipoCode];

export const CfeTipoLabel: Record<number, string> = {
  101: 'eTicket',
  102: 'Nota de Crédito',
  182: 'Resguardo',
};

export interface CfeDocument {
  id: ID;
  recibo_id: ID;
  cfe_tipo_code: CfeTipoCode;
  cfe_serie: string | null;
  cfe_numero: number | null;
  cfe_cae_autorizacion: string | null;
  cfe_cod_seguridad: string | null;
  cfe_url_qr: string | null;
  // Original fiscal snapshots returned by the document detail endpoint.
  xml_entrada?: string | null;
  xml_respuesta?: string | null;
  monto_gravado: number;
  monto_iva: number;
  monto_total: number;
  moneda: Currency;
  receptor_documento: string | null;
  receptor_nombre: string | null;
  receptor_fiscal?: string | null; // Versioned JSON identity used by credit notes.
  cfe_firmado_ok: boolean;
  cfe_confirmado: boolean;
  cfe_enviado: boolean;
  cfe_fecha_envio: string | null;
  dgi_estado?: 'SIN_CONSULTAR' | 'PENDIENTE' | 'ACEPTADO' | 'ACEPTADO_O_NC' | 'RECHAZADO' | 'ANULADO' | 'RECHAZADO_O_ANULADO' | 'DESCONOCIDO';
  dgi_estado_taface?: string | null;
  dgi_motivo_rechazo?: string | null;
  dgi_fecha_consulta?: string | null;
  dgi_error_consulta?: string | null;
  repair_original_id?: number;
  repair_replacement_id?: number;
  repair_original_number?: string;
  repair_replacement_number?: string;
  repair_phase?: string;
  indicador_anulacion?: boolean | number | null;
  error_message: string | null;
  warning_message: string | null;
  original_cfe_id: ID | null;
  created_at: string;
  updated_at: string;
  // Joined fields (from pending list / document detail)
  numero_recibo?: string;
  tipo_pago?: string;
  numero_contrato?: string;
}

export interface CfePendingItem extends CfeDocument {
  numero_recibo: string;
  tipo_pago: string;
  numero_contrato: string;
}

export interface CfeGenerateResult {
  success: boolean;
  message: string;
  documents: Array<{
    success: boolean;
    message: string;
    cfe_document_id?: number;
    cfe_tipo?: string;
    warning?: string | null;
    raw_error?: string | null;
    error?: string | null;
  }>;
}
